import brandPortalMessages from "@faire/web-api/routes/brand-portal/messages";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../../common/Bold";
import { LiItem } from "../../common/LiItem";
export var SOYOProcessing = function SOYOProcessing() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "M5A5R8",
    defaultMessage: [{
      "type": 0,
      "value": "To update the tracking information for an order that hasn’t been shipped yet, follow these steps:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "JUmURU",
    defaultMessage: [{
      "type": 0,
      "value": "Navigate to your Orders tab and select the order you wish to update."
    }]
  }))), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "hsC0PT",
    defaultMessage: [{
      "type": 0,
      "value": "On the order details page, choose the Edit option next to the shipping details."
    }]
  }))), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "If87ZM",
    defaultMessage: [{
      "type": 0,
      "value": "Update the necessary shipping information such as carrier, tracking number and expected ship date."
    }]
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "noKs1A",
    defaultMessage: [{
      "type": 0,
      "value": "We also recommend letting your retailer know about the changes to shipping details through "
    }, {
      "children": [{
        "type": 0,
        "value": "Faire Messenger"
      }],
      "type": 8,
      "value": "ButtonFormatting"
    }, {
      "type": 0,
      "value": " to avoid confusion."
    }],
    values: {
      ButtonFormatting: function ButtonFormatting(chunks) {
        return FaireMessagingFormatting(chunks);
      }
    }
  })));
};
var FaireMessagingFormatting = function FaireMessagingFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalMessages(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};